import { useEffect, RefObject } from 'react';

const useClickOutside = (ref: RefObject<HTMLElement | null>, isActive: boolean, onClickOutside: () => void): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClickOutside();
      }
    };

    if (isActive) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, isActive, onClickOutside]);
};

export default useClickOutside;
